import type { HighnoteEnvironment, InvalidCredentialError } from ".";

export interface DocumentUploadElementConfig {
  // A valid [DOMString](https://developer.mozilla.org/en-US/docs/Web/API/DOMString) that is a valid CSS Selector.
  //
  // Examples: "#foo", ".bar", '[data-foo="bar"]'
  //
  selector: string;
}

export interface DocumentUploadSdkConfig {
  clientToken: string;

  documentUploadSessionId: string;

  environment?: HighnoteEnvironment;

  documentUploadComponent: DocumentUploadElementConfig;

  onError: (error: DocumentUploadError) => void;

  onLoad: (response: Element) => void;

  onSuccess: (response: boolean) => void;
}

export interface DocumentUploadRenderedComponent {
  // Unmount all of the embedded dom to refresh token.
  unmount: () => void;

  endSession: () => Promise<boolean>;
}

export type DocumentUploadRequestError = Readonly<{
  name: "DocumentUploadRequestError";
  message: string;
}>;

export interface DocumentUploadConfigError {
  name: "DocumentUploadConfigError";
  message: string;
}

export interface GenericDocumentUploadError {
  name: "GenericDocumentUploadError";
  message: string;
}

// All the errors that can be returned onError.
export type DocumentUploadError = Readonly<
  | DocumentUploadConfigError
  | DocumentUploadRequestError
  | GenericDocumentUploadError
  | InvalidCredentialError
>;
